module.exports = __webpack_public_path__ + "static/media/empty-state-no-results.ad8c36b9.svg";